export function findDistrict(googleObj) {
  const district = googleObj.address_components.find(
    (field) =>
      field.types.includes('administrative_area_level_4') &&
      field.types.includes('political')
  )

  return district?.long_name || null
}
